import { useSyncExternalStore } from "react";
import { isAndroid, isIOS, isMobile, isTablet } from "react-device-detect";
import { useMediaQuery } from "usehooks-ts";
import { getWhiteLabel } from "../utils/white-label";

const TABLET_QUERY = "(min-width: 768px) and (max-width: 1024px)";
const LOCAL_STORAGE_KEY = "dismiss-app-banner";
const ONE_DAY = 24 * 60 * 60 * 1000;

const getSnapshot = () => {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!raw) return undefined;

  try {
    const timestamp = Number(raw);
    const now = Date.now();

    if (now - timestamp >= ONE_DAY) {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
      return undefined;
    }

    return raw;
  } catch {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    return undefined;
  }
};

const subscribe = (callback: () => void) => {
  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === LOCAL_STORAGE_KEY) {
      callback();
    }
  };
  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
};

const dismissBanner = () => {
  const timestamp = Date.now().toString();
  localStorage.setItem(LOCAL_STORAGE_KEY, timestamp);

  // Trigger manual event to sync in the same tab
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: LOCAL_STORAGE_KEY,
      newValue: timestamp,
    }),
  );
};

export const useShowMobileAppDownload = () => {
  const storedDismiss = !!useSyncExternalStore(subscribe, getSnapshot);
  const { partnerRef } = getWhiteLabel();
  const isMozio = partnerRef === "mozio_web" || partnerRef === "mozio";
  const isTabletMQ = useMediaQuery(TABLET_QUERY);
  const isSupportedDevice =
    (isAndroid || isIOS) && isMobile && !isTablet && !isTabletMQ;
  const isButtonShown = isSupportedDevice && isMozio;
  const isBannerShown = isButtonShown && !storedDismiss;

  return {
    isButtonShown,
    isBannerShown,
    dismissBanner,
  };
};
